module.exports = __webpack_public_path__ + "static/media/call-feedback-content-issues-color.02857d57.svg";